import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SendPaymentInstructionModelService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.model.service';
import { SendPaymentTypeEnum } from '@nttp/enum/send-payment-type.enum';

@Component({
  selector: 'np-balance-trade-available',
  templateUrl: './balance-trade-available.component.html',
  styleUrls: ['./balance-trade-available.component.scss']
})
export class BalanceTradeAvailableComponent implements OnInit {

  sortTrade = '';
  sortDate = '';
  checkAvailableBalance = true;
  totalSelected: number;
  tradeList = [];
  @Input() sendPaymentType = SendPaymentTypeEnum.SendPaymentDashboard;

  constructor(
    public paymentModel: SendPaymentInstructionModelService,
    private toastr: ToastrService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.tradeList = [...this.paymentModel.tradeList];
    this.calculatedTotalSelected();
  }

  public checkItem($event, item) {
    item.checked = $event.checked;
    this.calculatedTotalSelected();
  }

  public sortTradeList(columnName) {
    let sortType = '';
    if (columnName === 'tradeReference') {
      this.sortDate = '';
      this.sortTrade = this.sortTrade === 'asc' ? 'desc' : 'asc';
      sortType = this.sortTrade;
    } else {
      this.sortTrade = '';
      this.sortDate = this.sortDate === 'asc' ? 'desc' : 'asc';
      sortType = this.sortDate;
    }

    if (sortType === 'desc') {
      this.tradeList.sort((previous, next) => {
        return previous[columnName] > next[columnName] ? 1 : -1;
      });
    } else {
      this.tradeList.sort((previous, next) => {
        return previous[columnName] > next[columnName] ? -1 : 1;
      });
    }
  }

  calculatedTotalSelected() {
    let total = this.checkAvailableBalance ? this.paymentModel.availableBalance : 0;
    const tradeSelected = this.tradeList.filter(item => item.checked);
    if (tradeSelected.length > 0) {
      tradeSelected.forEach(element => {
        total += element.boughtOfferInfo.quantity;
      });
    }
    this.totalSelected = total < this.paymentModel.amount ? total : this.paymentModel.amount;
  }

  checkChangAvailableBalance() {
    this.checkAvailableBalance = !this.checkAvailableBalance;
    this.calculatedTotalSelected();
  }

  public nextTabPayment() {

    if (!this.checkAvailableBalance) {
      this.toastr.error('You should use your available balance for the payment.');
      return;
    }
    if (this.totalSelected < this.paymentModel.amount) {
      this.toastr.error('Insufficient funds for payment. Please select more or update payment amount.');
      return;
    }

    const tradeDrawdown = [];
    const tradeFundPayment = [];

    if (this.paymentModel.availableBalance < this.paymentModel.amount) {
      const tradeSelected = this.tradeList.filter(item => item.checked);
      if (tradeSelected.length > 0) {
        tradeSelected.sort((previous, next) => {
          if (previous.valueDate > next.valueDate) {
            return 1;
          } else {
            return -1;
          }
        });
        let currentTotal = this.paymentModel.availableBalance;
        tradeSelected.forEach(item => {
          // For some reason javascript sometimes does not add up to zero, and leaves a tiny tiny amount in totalmatching number
          // that is why we're truncating to two decimal places before comparing to zero.
          currentTotal = parseFloat((currentTotal + item.boughtOfferInfo.quantity).toFixed(2));
          if (currentTotal <= this.paymentModel.amount) {
            if (new Date(item.valueDate).setHours(0, 0, 0, 0) > new Date(this.paymentModel.paymentDate).setHours(0, 0, 0, 0)) {
              tradeDrawdown.push({
                tradeReference: item.tradeReference,
                tradeId: item.id,
                sellCurrencyCode: item.soldOfferInfo.currencyCode,
                sellAmount: item.soldOfferInfo.quantity,
                exchangeRate: item.exchangeRate,
                buyCurrencyCode: item.boughtOfferInfo.currencyCode,
                buyAmount: item.boughtOfferInfo.quantity,
                isSellChanged: false,
              });
            } else {
              tradeFundPayment.push(item.id);
            }
          } else {
            const amountDraw = parseFloat((this.paymentModel.amount - currentTotal + item.boughtOfferInfo.quantity).toFixed(2));
            if (amountDraw > 0) {
              if (new Date(item.valueDate).setHours(0, 0, 0, 0) > new Date(this.paymentModel.paymentDate).setHours(0, 0, 0, 0)) {
                const sellAmount =
                  (item.soldOfferInfo.quantity * (amountDraw / item.boughtOfferInfo.quantity)).toFixed(2);
                tradeDrawdown.push({
                  tradeReference: item.tradeReference,
                  tradeId: item.id,
                  sellCurrencyCode: item.soldOfferInfo.currencyCode,
                  sellAmount: parseFloat(sellAmount),
                  exchangeRate: item.exchangeRate,
                  buyCurrencyCode: item.boughtOfferInfo.currencyCode,
                  buyAmount: amountDraw,
                  isSellChanged: false,
                });
              } else {
                tradeFundPayment.push(item.id);
              }
            }
          }
        });
      }
    }

    this.paymentModel.tradeDrawdown = tradeDrawdown;
    this.paymentModel.tradeFundPayment = tradeFundPayment;
    this.paymentModel.step = tradeDrawdown.length > 0 ? this.paymentModel.sendPaymentStep.drawdownSummary : this.paymentModel.sendPaymentStep.paymentConfirmation;
  }

  public goBack() {
    if (this.sendPaymentType === SendPaymentTypeEnum.SendPaymentDashboard) {
      this.dialog.closeAll();
      this.paymentModel.clearData();
    } else {
      this.paymentModel.step = this.paymentModel.sendPaymentStep.paymentInfo;
    }
  }
}
